var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburguer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_937_670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8478 7.8877H1.14045C0.783516 7.8877 0.494141 8.17704 0.494141 8.53401C0.494141 8.89098 0.783516 9.18032 1.14045 9.18032H15.8478C16.2048 9.18032 16.4941 8.89098 16.4941 8.53401C16.4941 8.17707 16.2048 7.8877 15.8478 7.8877Z",
    fill: "#002447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8478 2.98535H1.14045C0.783516 2.98535 0.494141 3.27473 0.494141 3.63166C0.494141 3.9886 0.783516 4.27798 1.14045 4.27798H15.8478C16.2048 4.27798 16.4941 3.9886 16.4941 3.63166C16.4941 3.27473 16.2048 2.98535 15.8478 2.98535Z",
    fill: "#002447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8478 12.7905H1.14045C0.783516 12.7905 0.494141 13.0799 0.494141 13.4368C0.494141 13.7938 0.783516 14.0832 1.14045 14.0832H15.8478C16.2048 14.0832 16.4941 13.7938 16.4941 13.4368C16.4941 13.0799 16.2048 12.7905 15.8478 12.7905Z",
    fill: "#002447"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_937_670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.494141 0.53418)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburguer);
export default __webpack_public_path__ + "static/media/hamburguer.e96ec84f1b3a7043f1c01f44bf7337ca.svg";
export { ForwardRef as ReactComponent };